import { QuestionnaireAnswers } from './types';

export const QUESTIONNAIRE_VERSION = 'v1';

export const EXPERIENCE_OPTIONS = [
  { label: 'New to environmental databases', value: 'new' },
  { label: 'Some familiarity', value: 'some_familiarity' },
  { label: 'Experienced user', value: 'experienced' },
] as const;

export const USE_CASE_OPTIONS = [
  { label: 'Corporate or organizational footprinting', value: 'corporate_footprinting' },
  { label: 'Eco-design and product development', value: 'eco_design' },
  { label: 'Environmental declarations and disclosures', value: 'environmental_declarations' },
  { label: 'Environmental or sustainability consulting', value: 'sustainability_consulting' },
  { label: 'Environmental database development or management', value: 'database_development' },
  { label: 'Footprinting and impact screening', value: 'footprinting_screening' },
  { label: 'LCA modeling and studies', value: 'lca_modeling' },
  { label: 'Research or academic use', value: 'research' },
  { label: 'Supply chain analysis and optimization', value: 'supply_chain' },
  { label: 'Software or tool development', value: 'software_development' },
  { label: 'Teaching or training', value: 'teaching' },
  { label: 'Other', value: 'other' },
] as const;

export const INDUSTRY_OPTIONS = [
  'Automotive',
  'Chemicals',
  'Consulting & Professional Services',
  'Construction, Engineering & Real Estate',
  'Consumer Goods, Retail, Textiles & Apparel',
  'Education & Research',
  'Food & Beverage',
  'Government & Policymakers',
  'Healthcare, Pharmaceuticals & Biotechnology',
  'Industrial Equipment, Machinery & Aerospace',
  'Metals, Mining & Packaging',
  'Oil, Gas & Utilities',
  'Paper, Printing & Forest Products',
  'Recreation & Environment',
  'Software, Hardware & IT Services',
  'Transportation, Logistics & Distribution',
  'Other',
] as const;

export const INITIAL_ANSWERS: QuestionnaireAnswers = {
  experienceLevel: null,
  useCases: [],
  useCasesOther: '',
  industry: null,
};
